/* New Grange — gedrag producthero.
   Alleen native browser-API's; geen externe libraries.

   Fase 1 (ongewijzigd behouden): mobiele sticky koopbalk, basis show/hide +
   prijs/label-sync.

   Toegevoegd voor Jan's PDP (turn 4a/4b, §24-26 van de opdracht):
   - Zichtbaarheidsanker verplaatst van de losse hoofdknop naar het hele
     interesseblok (.ng-jan-interest), zodat de balk ook op quote-only/€0-
     producten verschijnt (die hebben geen #ProductSubmitButton-omdat de
     hoofdactie daar een offerte-link is, geen add-to-cart-knop).
   - Onderdrukking wanneer de cart-drawer of het menu open staat, zodat er
     nooit twee overlays/balken tegelijk zichtbaar zijn en er geen content
     onbereikbaar wordt.
   - NgRoomChips: ruimte-kiezer voor het interesseblok (single-select,
     opnieuw klikken = deselect). Zet een verborgen line-item property
     "Ruimte" in het add-to-cart-formulier en voegt "room=" toe aan de href
     van ieder [data-ng-room-link]-element (Maatwerk/Vraag/plakbalk),
     bovenop de bestaande, server-side opgebouwde ng-form-url-parameters. */

if (!customElements.get('ng-sticky-cta')) {
  customElements.define(
    'ng-sticky-cta',
    class NgStickyCta extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.anchor = document.querySelector('.ng-jan-interest') || document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.button = this.querySelector('button');
        this.priceTarget = this.querySelector('[data-ng-sticky-price]');

        if (!this.anchor) return;

        this.onScrollOrResize = this.updateVisibility.bind(this);
        window.addEventListener('scroll', this.onScrollOrResize, { passive: true });
        window.addEventListener('resize', this.onScrollOrResize, { passive: true });
        this.suppressInterval = window.setInterval(this.updateVisibility.bind(this), 400);
        this.updateVisibility();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => this.sync());
        }
      }

      disconnectedCallback() {
        if (this.onScrollOrResize) {
          window.removeEventListener('scroll', this.onScrollOrResize);
          window.removeEventListener('resize', this.onScrollOrResize);
        }
        if (this.suppressInterval) window.clearInterval(this.suppressInterval);
        this.variantChangeUnsubscriber?.();
      }

      /* Zichtbaar zodra het interesseblok boven de viewport uit beeld is
         gescrold — nooit wanneer cart-drawer of menu open staat. */
      updateVisibility() {
        const scrolledPast = this.anchor.getBoundingClientRect().bottom < 0;
        const cartOpen = !!document.querySelector('cart-drawer.active');
        const menuOpen = !!document.querySelector('.menu-opening');
        const shouldShow = scrolledPast && !cartOpen && !menuOpen;
        this.toggleAttribute('hidden', !shouldShow);
      }

      sync() {
        const price = document
          .getElementById(`price-${this.sectionId}`)
          ?.querySelector('.price-item--regular');
        if (price && this.priceTarget) {
          this.priceTarget.textContent = price.textContent.trim();
        }

        if (this.button && this.mainButton) {
          const disabled = this.mainButton.hasAttribute('disabled');
          this.button.toggleAttribute('disabled', disabled);
          const label = this.mainButton.querySelector('span')?.textContent.trim();
          if (label) this.button.textContent = label;
        }
      }
    }
  );
}

if (!customElements.get('ng-room-chips')) {
  customElements.define(
    'ng-room-chips',
    class NgRoomChips extends HTMLElement {
      connectedCallback() {
        this.chips = Array.from(this.querySelectorAll('[data-ng-room-value]'));
        this.chips.forEach((chip) => {
          chip.addEventListener('click', () => this.toggle(chip));
        });
      }

      toggle(chip) {
        const wasActive = chip.getAttribute('aria-pressed') === 'true';
        this.chips.forEach((c) => c.setAttribute('aria-pressed', 'false'));
        if (!wasActive) chip.setAttribute('aria-pressed', 'true');
        this.applyRoom(wasActive ? '' : chip.dataset.ngRoomValue);
      }

      applyRoom(room) {
        // Line-item property "Ruimte": alleen aanwezig in de form-payload
        // wanneer een ruimte gekozen is (leeg -> geen property, i.p.v. een
        // property met een lege waarde).
        document.querySelectorAll('.ng-jan-room-property').forEach((input) => {
          if (room) {
            input.name = 'properties[Ruimte]';
            input.value = room;
          } else {
            input.removeAttribute('name');
            input.value = '';
          }
        });

        // room= toevoegen aan de bestaande, server-side opgebouwde CTA-URL's
        // (Maatwerk / Stel een vraag / plakbalk) zonder de overige
        // ng-form-url-parameters aan te tasten.
        document.querySelectorAll('[data-ng-room-link]').forEach((link) => {
          try {
            const url = new URL(link.getAttribute('href'), window.location.origin);
            if (room) {
              url.searchParams.set('room', room);
            } else {
              url.searchParams.delete('room');
            }
            link.setAttribute('href', url.pathname + url.search);
          } catch (e) {
            /* Ongeldige/relatieve href zonder base blijft ongemoeid. */
          }
        });
      }
    }
  );
}
